export const accordion = (props) => {
  return {
    isOpen: false,
    initialiazed: false,
    get classes() {
      return { active: this.isOpen };
    },
    mounted($el) {
      if (!this.initialiazed) {
        window.addEventListener("resize", () => {
          this.calculateHeight($el);
        });
        this.calculateHeight($el);
        this.initialiazed = true;
      }
      
    },
    calculateHeight($el) {
      $el.style.setProperty("--close-height", "auto");
      $el.style.setProperty("--open-height", "auto");
      $el.style.setProperty("--open-height", `${$el.offsetHeight}px`);
      $el.style.setProperty("--close-height", "0px");
    },
  };
};